var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BellIcon from '@/assets/icons/bell.svg';
import NecLogoDark from '@/assets/icons/logo-nec-dark.svg';
import StartMenuIcon from '@/assets/icons/start-menu-icon.svg';
import { DropDownButton } from '@/components/button/DropdownButton';
import NecoreDrawer from '@/components/drawer';
import { getMenu } from '@/configs/menu';
import { logoutRequest } from '@/store/auth/actions';
import { isSigningOut, userInfoSelectUserInfo } from '@/store/auth/selectors';
import { clickMenuUser } from '@/store/menuUser/reducer';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { AppBar, Avatar, Box, IconButton, Stack, Toolbar, Typography, useTheme, } from '@mui/material';
import { useCallback, useEffect, useMemo, useState, } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import AppIcon from '../app-icon';
import { Breadcrumbs } from '../navigation/BreadCrumb/BreadCrumb';
import { handleCheckLogin, handleCheckLoginType } from '@/store/login/reducer';
import { ROLE } from '@/utils/constants';
import { ADMIN_SETTING_MENU, USER_SETTING_MENU, } from '@/modules/mobility-console/pages/settings/index-const';
import 'aws-amplify/auth/enable-oauth-listener';
import { translateNestedArrays } from './container';
import { getFirstCharacterOfString } from '@/utils/helpers';
import { API_STATUS_CODE } from '@/utils/api/types';
import { toast } from 'react-toastify';
import { usersService } from '@/services/setting/adminitrator/users';
var drawerWidth = 298;
var checkMenuId = function (userInfo) {
    var _a;
    var menuId;
    switch ((_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.setting) === null || _a === void 0 ? void 0 : _a.role) {
        case ROLE.SUPER_ADMIN:
            menuId = ADMIN_SETTING_MENU.ORGANIZATIONS;
            break;
        case ROLE.ORGANIZATION_ADMIN:
            menuId = ADMIN_SETTING_MENU.USER_CONFIGURATION;
            break;
        case ROLE.USER:
            menuId = USER_SETTING_MENU.PROFILE;
            break;
        default:
            menuId = '';
            break;
    }
    return menuId;
};
var MainLayout = function () {
    var _a, _b, _c;
    var _d = useState(true), open = _d[0], setOpen = _d[1];
    var _e = useState(), userData = _e[0], setUserData = _e[1];
    var getProfile = usersService.getProfile;
    var t = useTranslation('translation').t;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var userInfo = useSelector(userInfoSelectUserInfo);
    var _isSigningOut = useSelector(isSigningOut);
    var menus = useSelector(function (state) { return state.auth; }).menus;
    var theme = useTheme();
    var _f = useState(true), isProfile = _f[0], setIsProfile = _f[1];
    var DEFAULT_OPEN_DRAWE = 'calc(100% - 72px)';
    var getUserProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data, errorCode, errorMessage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getProfile()];
                case 1:
                    _a = _b.sent(), data = _a.data, errorCode = _a.errorCode;
                    if (errorCode === API_STATUS_CODE.SUCCESS) {
                        setUserData(data);
                        return [2 /*return*/, data];
                    }
                    else {
                        errorMessage = t("message:".concat(errorCode));
                        toast.error(errorMessage);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleLogout = useCallback(function () {
        dispatch(logoutRequest());
        dispatch(handleCheckLogin({ is_login: false }));
        dispatch(handleCheckLoginType({ login_type: 0 }));
    }, [dispatch]);
    var handleProfile = useCallback(function () {
        navigate('/settings');
        dispatch(clickMenuUser({ id: 'PROFILE' }));
        var menu = document.getElementById('demo-customized-menu');
        if (menu) {
            menu.style.visibility = 'hidden';
        }
    }, [dispatch]);
    var handleClickSettings = useCallback(function () {
        setIsProfile(false);
        navigate('/settings');
        var menu = document.getElementById('demo-customized-menu');
        if (menu) {
            menu.style.visibility = 'hidden';
        }
    }, [dispatch]);
    useEffect(function () {
        if (!isProfile) {
            var menuId = checkMenuId(userInfo);
            dispatch(clickMenuUser({ id: menuId }));
        }
    }, [navigate]);
    useEffect(function () {
        getUserProfile();
    }, []);
    var menuUser = useMemo(function () { return [
        {
            id: 'profile',
            onClick: handleProfile,
            label: 'Profile',
            icon: PersonIcon,
        },
        {
            id: 'settings',
            onClick: handleClickSettings,
            label: 'Settings',
            icon: SettingsOutlinedIcon,
        },
        {
            id: 'logout',
            onClick: handleLogout,
            label: 'Logout',
            icon: LogoutIcon,
        },
    ]; }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleLogout]);
    var translateLabels = useCallback(function (arr) { return arr.map(function (obj) { return translateNestedArrays(obj, t); }); }, [t]);
    var getMenus = useMemo(function () {
        if (menus) {
            return translateLabels(menus);
        }
        else
            return [];
    }, [menus, translateLabels]);
    var handleDrawerToggle = useCallback(function () {
        setOpen(!open);
    }, [open]);
    return (userInfo && (_jsxs(Box, { sx: { display: 'flex' }, children: [_jsx(AppBar, { position: "fixed", sx: {
                    width: {
                        sm: open ? "calc(100% - ".concat(drawerWidth, "px)") : DEFAULT_OPEN_DRAWE,
                    },
                    ml: { sm: "".concat(drawerWidth, "px") },
                    bgcolor: theme.palette.background.default,
                    backgroundImage: theme.palette.mode === 'dark' ? 'unset' : '',
                }, children: _jsx(Toolbar, { sx: {
                        borderBottom: "1px solid ".concat(theme.palette.border.container, " "),
                        '&.MuiToolbar-root': { padding: 0 },
                    }, children: _jsxs(Stack, { direction: "row", justifyContent: "space-between", width: 1, children: [_jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", children: [_jsx(IconButton, { color: "inherit", "aria-label": "open drawer", edge: "start", id: "drawer_btn", onClick: handleDrawerToggle, sx: { rotate: open ? '0' : '180deg' }, children: _jsx(AppIcon, { icon: StartMenuIcon }) }), _jsx(Typography, { variant: "h5", fontWeight: "bold", children: t('title') })] }), _jsxs(Stack, { direction: "row", spacing: 2.25, alignItems: "center", children: [_jsx(AppIcon, { icon: BellIcon }), _jsxs(Stack, { spacing: 1.5, direction: "row", children: [_jsxs(Stack, { justifyContent: "end", children: [_jsx(Typography, { textAlign: "right", variant: "body1", textTransform: "none", children: (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== null && _a !== void 0 ? _a : '' }), _jsx(Typography, { fontSize: 10, lineHeight: 1.2, color: "text.secondary", textTransform: "none", textAlign: "right", children: (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.setting) === null || _b === void 0 ? void 0 : _b.role })] }), _jsxs(Stack, { spacing: 0.5, direction: "row", alignItems: "center", children: [_jsx(Avatar, __assign({ alt: "", src: (_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.setting) === null || _c === void 0 ? void 0 : _c.avatar_image, sx: { width: 32, height: 32, fontSize: '1rem' } }, getFirstCharacterOfString(userData === null || userData === void 0 ? void 0 : userData.full_name))), _jsx(DropDownButton, { menu: menuUser })] })] })] })] }) }) }), _jsx(Box, { component: "nav", sx: {
                    width: { sm: open ? drawerWidth : '72px' },
                    flexShrink: { sm: 0 },
                }, "aria-label": "mailbox folders", children: _jsx(NecoreDrawer, { logo: NecLogoDark, onToggle: handleDrawerToggle, open: open, menu: getMenus, width: drawerWidth }) }), _jsxs(Box, { component: "main", flexGrow: 1, sx: {
                    width: {
                        sm: open ? "calc(100% - ".concat(drawerWidth, "px)") : DEFAULT_OPEN_DRAWE,
                    },
                }, children: [_jsx(Toolbar, {}), _jsxs(Box, { padding: "16px 24px 0px 24px", sx: { height: 'calc(100vh - 150px)' }, children: [_jsx(Box, { padding: "0px 0px 24px 0px", children: _jsx(Breadcrumbs, { menuGroup: getMenu(t) }) }), _jsx(Outlet, {})] })] })] })));
};
export default MainLayout;
